import React from 'react';
import styles from './PFSWaveContainer.module.css';
import PropTypes from 'prop-types';
import PFSWaveTop from './PFSWaveTop';
import PFSWaveBottom from './PFSWaveBottom';

const PFSWaveContainer = ({ color = '#153459', children }) => {
  return (
    <div className={styles.PFSWaveContainer} data-testid='PFSWaveContainer'>
      <div style={{ marginBottom: '-1px' }} className={styles.WaveContainer}>
        <PFSWaveTop color={color} />
      </div>
      <div
        data-testid='WaveContentWrapper'
        id={styles.ContentWrapper}
        style={{ backgroundColor: color || '#153459' }}
      >
        {children}
      </div>
      <div style={{ marginTop: '-1px' }} className={styles.WaveContainer}>
        <PFSWaveBottom color={color} />
      </div>
    </div>
  );
};

PFSWaveContainer.propTypes = {
  color: PropTypes.string,
};

export default PFSWaveContainer;
